import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M28 130q0-30 32-40 10-30 40-30t38 30l40-20-10 30-24 8v22h26v12h-40v16H90v-16H64q-4 14-14 14-14 0-14-12Z" }, null, -1),
    _createElementVNode("circle", {
      cx: "108",
      cy: "82",
      r: "4",
      fill: "var(--mc-avatar)"
    }, null, -1),
    _createElementVNode("path", {
      fill: "var(--mc-avatar)",
      d: "M78 116h14v6H78zM148 98l4 10 4-10zM158 98l4 10 4-10z"
    }, null, -1)
  ]))]))
}
export default { render: render }